document.addEventListener('DOMContentLoaded', () => {
  const expressCheckoutSection = document.getElementById(
    'express-checkout-section',
  );
  const creditCardButton = document.getElementById(
    'credit-card-checkout-button',
  );
  const termsCheckbox = document.getElementById('cart-terms-checkbox');

  // Track which APMs have reported and which are available
  const apmStatus = {
    applePay: { reported: false, available: false },
    googlePay: { reported: false, available: false },
    paypal: { reported: false, available: false },
  };

  // Listen for APM availability events
  window.addEventListener('apm-availability', (event) => {
    const { type, available } = event.detail;

    if (apmStatus[type]) {
      apmStatus[type].reported = true;
      apmStatus[type].available = available;

      console.log(
        `APM Manager: ${type} is ${available ? 'available' : 'not available'}`,
      );

      checkAllReported();
    }
  });

  function checkAllReported() {
    const allReported = Object.values(apmStatus).every((apm) => apm.reported);

    if (!allReported) {
      return;
    }

    const anyAvailable = Object.values(apmStatus).some((apm) => apm.available);

    if (!anyAvailable && expressCheckoutSection) {
      console.log(
        'APM Manager: No APMs available, hiding Express Checkout section',
      );
      expressCheckoutSection.style.display = 'none';
    }
  }

  if (termsCheckbox && creditCardButton) {
    if (!termsCheckbox.checked) {
      creditCardButton.disabled = true;
      creditCardButton.style.opacity = '0.5';
      creditCardButton.style.cursor = 'not-allowed';
    }

    termsCheckbox.addEventListener('change', () => {
      if (termsCheckbox.checked) {
        creditCardButton.disabled = false;
        creditCardButton.style.opacity = '1';
        creditCardButton.style.cursor = 'pointer';
      } else {
        creditCardButton.disabled = true;
        creditCardButton.style.opacity = '0.5';
        creditCardButton.style.cursor = 'not-allowed';
      }
    });
  }

  setTimeout(() => {
    const anyReported = Object.values(apmStatus).some((apm) => apm.reported);
    const anyAvailable = Object.values(apmStatus).some((apm) => apm.available);

    if (!anyReported || !anyAvailable) {
      console.log('APM Manager: Timeout reached, no APMs available');
      if (expressCheckoutSection) {
        expressCheckoutSection.style.display = 'none';
      }
    }
  }, 10000);
});
